// extracted by mini-css-extract-plugin
export var container = "FeatureTextBlock-module--container--12995";
export var container_center = "FeatureTextBlock-module--container_center--844cc";
export var content_column = "FeatureTextBlock-module--content_column--6b3f3";
export var description_wrapper = "FeatureTextBlock-module--description_wrapper--24b64";
export var label_wrapper = "FeatureTextBlock-module--label_wrapper--e309d";
export var text = "FeatureTextBlock-module--text--d92af";
export var title_wrapper = "FeatureTextBlock-module--title_wrapper--adf51";